import type { CanonicalTweet } from '@sweetistics/contracts/tweets-canonical';
import { CanonicalTweetSchema } from '@sweetistics/contracts/tweets-canonical';
export interface ParseTweetOptions {
  /**
   * Optional callback invoked when parsing fails. Useful for logging without
   * forcing every call-site to wrap try/catch blocks.
   */
  onError?: (error: unknown) => void;
}

export function parseCanonicalTweet(raw: unknown, options?: ParseTweetOptions): CanonicalTweet {
  try {
    return CanonicalTweetSchema.parse(raw);
  } catch (error) {
    options?.onError?.(error);
    throw error instanceof Error ? error : new Error('Invalid canonical tweet payload');
  }
}

export function parseCanonicalTweetOrNull(raw: unknown, options?: ParseTweetOptions): CanonicalTweet | null {
  try {
    return parseCanonicalTweet(raw, options);
  } catch {
    return null;
  }
}
